import React from 'react';
import clsx from 'clsx';
import { UseFormRegisterReturn } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { Palette } from 'core/config';

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px #ddd, inset 0 -1px 0 #ddd',
        backgroundColor: '#f5f8fa',
        '$root.Mui-focusVisible &': {
            outline: `1px auto ${Palette.ORANGE}`,
            outlineOffset: 2,
        },
    },
    checkedIcon: {
        boxShadow: 'none',
        backgroundColor: `${Palette.ORANGE}`,
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'%3E%3Cpath' +
                ' fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 ' +
                '1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z\' fill=\'%23fff\'/%3E%3C/svg%3E")',
            content: '""',
        }
    }
});

interface Props {
    name: string;
    checked: boolean;
    input?: UseFormRegisterReturn;
    setValue?: (name: string, value: any) => void;
    onChange?: any;
}

export const FormCheckbox: React.FunctionComponent<Props> = ({
    name,
    checked,
    input,
    setValue,
    onChange
}) => 
{
    const classes = useStyles();
    const onChangeAbstraction = onChange ? onChange : (e: React.ChangeEvent<HTMLInputElement>) => 
    {
        setValue && setValue(name, e.target.value);
    };

    return (
        <Checkbox
            className={classes.root}
            checked={checked}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            inputProps={{ 'aria-label': 'decorative checkbox' }}
            {...input}
            onChange={onChangeAbstraction}
        />
    );
};